import React from "react";
import { Plus, Building2, GraduationCap, Briefcase, FileText, UserPlus } from "lucide-react";
import { Card } from "antd";
import { useNavigate } from "react-router-dom";
import HeaderComponent from "components/card/HeaderComponent";

const DASHBOARD_CARDS = [
  {
    title: "Employee",
    description: "Active team members",
    route: "/console/employee-details",
    icon: UserPlus,
    iconBg: "flat-blue",
  },
  {
    title: "Client",
    description: "Register a new client organization",
    route: "",
    icon: Building2,
    iconBg: "flat-purple",
  },
  {
    title: "Course",
    description: "Create a new training course",
    route: "",
    icon: GraduationCap,
    iconBg: "flat-teal",
  },
  {
    title: "Project",
    description: "Initialize a new project",
    route: "",
    icon: Briefcase,
    iconBg: "flat-orange",
  },
  {
    title: "Department",
    description: "Create a new department",
    route: "",
    icon: FileText,
    iconBg: "flat-cyan",
  },
];

const QuickDataEntry = () => {

  const navigate = useNavigate(); 
  
  const handleClick = (route) => {
    if (route) navigate(route);
  };

  return (
    <HeaderComponent
      title="Quick Data Entry"
      description="Add new records to the system"
      icon={<Plus className="w-5 h-5 text-emerald-600"/>}
      colorTheme="bg-emerald-100"
    >

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
      {DASHBOARD_CARDS.map((card, index) => {
        const Icon = card.icon;
        return (
        <Card
          key={index}
          onClick={() => handleClick(card.route)}
          className="flex flex-col rounded-xl cursor-pointer hover:shadow-lg transition-all border border-slate-200 dark:border-zinc-700 dark-mode-card"
        >
       
          <div className="items-right justify-start">
            <div >
              <div className={`flex items-center justify-center p-2 bg-text flex w-12 h-12  ${card.iconBg}`}>
                <Icon className="w-6 h-6"/>
              </div>
            </div>

            <h4 className="text-[14px] title-text">{card.title}</h4>
            <p className="text-[11px] muted-text">{card.description}</p>
          </div>
        </Card>
         );
      })}
    </div>
    </HeaderComponent>

  );
};

export default QuickDataEntry;
